var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card h-100"
  }, [_vm.selectedCycle === 1 ? _c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("Expanding the Data")]), _vm._m(0)]) : _vm.selectedCycle === 4 ? _c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("New Placement Data")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" ISBE has partnered with the Illinois Department of Employment Security (IDES) to obtain program completer employment in non-public education and early learning settings. The “Placement in Teaching” indicator within the 2021 Illinois Educator Preparation Profile includes placement data for both of these settings, as well as the Illinois public schools, which allows for a more holistic look at how each program is contributing to state needs. ")])]) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" The 2020 Illinois Educator Preparation Profile, Contribution to State Needs domain only considers the employment and persistence of program completers in Illinois public schools. "), _c('br'), _c('br'), _vm._v(" Future releases of IEPP will include program completers who work outside the public school system in Illinois. To do this, ISBE will partner with the Illinois Department of Employment Security (IDES) to gather data on program completers from Illinois preparation programs who obtain employment outside an Illinois public school but within the education sector (e.g., private schools, community-based organizations, or other education-related fields). "), _c('br'), _c('br'), _vm._v(" While these future efforts will enrich the report, the 2020 Illinois Educator Preparation Profile, Contribution to State Needs domain only considers the employment and persistence of program completers in Illinois public schools. ")]);
}];
export { render, staticRenderFns };